// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"f0e64dc5","317":"f3e508aa","319":"f3e508aa","393":"f3e508aa","595":"f3e508aa","660":"f3e508aa","754":"e0aeac69","944":"f3e508aa"}[chunkId] + ".chunk.css";
};